var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPieChart(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 490.1 490.1",
    style: {
      enableBackground: "new 0 0 490.1 490.1"
    },
    xmlSpace: "preserve",
    height: "1em",
    width: "1em",
    fill: "currentColor",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M279.7,228.95h193.2c9.5,0,17.2-7.7,17.2-17.2c0-51.3-18.7-100.8-52.7-139.2c-39.9-45.2-97.4-71.1-157.7-71.1       c-9.5,0-17.1,7.7-17.1,17.1v193.2C262.5,221.25,270.2,228.95,279.7,228.95z M296.8,36.55c44.1,4.3,85.2,25.2,114.8,58.7       c24.6,27.9,39.7,62.6,43.2,99.4h-158V36.55z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M218.5,51.65C98,51.65,0,149.65,0,270.15s98,218.5,218.5,218.5s218.5-98,218.5-218.5c0-9.5-7.7-17.2-17.1-17.2H235.7       V68.85C235.7,59.35,228,51.65,218.5,51.65z M401.9,287.35c-8.7,93.5-87.6,167-183.4,167c-101.6,0-184.2-82.6-184.2-184.2       c0-95.8,73.5-174.7,167-183.4v183.4c0,9.5,7.7,17.1,17.1,17.1h183.5L401.9,287.35L401.9,287.35z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPieChart);
export default __webpack_public_path__ + "static/media/pie-chart.3f035a6f.svg";
export { ForwardRef as ReactComponent };